<template>
<!-- field -->
<div class="">
    <div class="flex">
        <label for="copyright_text">Copyright text</label>
        <span v-if="$page.props.errors.copyright_text" class="errormessage">{{ $page.props.errors.copyright_text }}</span>
    </div>
    <input class="input-black" type="text" id="copyright_text" :value="form.copyright_text"
    @input="$emit('update:copyrightText', $event.target.value)">
</div>
<!-- end field -->

<!-- field -->
<div class="">
    <div class="flex">
        <label for="copyright_link">Copyright link</label>
        <span v-if="$page.props.errors.copyright_link" class="errormessage">{{ $page.props.errors.copyright_link }}</span>
    </div>
    <input class="input-black" type="text" id="copyright_link" :value="form.copyright_link"
    @input="$emit('update:copyrightLink', $event.target.value)">
</div>
<!-- end field -->

<!-- field -->
<div v-if="form.object_type == 'file_meta_data_marker'">
    <div class="flex">
        <label for="physical_width">Physical width (in cm.)</label>
    </div>
    <input class="input-black" type="number" id="physical_width" :value="form.physical_width"
    @input="$emit('update:physicalWidth', $event.target.value)">
</div>
<!-- end field -->

<!-- fields -->
<div v-if="form.object_type == 'file_meta_data_chroma_video'">
    <div class="flex">
        <label for="color">Color</label>
    </div>
    <input type="color" id="color" @input="$emit('update:color', $event.target.value)"
    :value="form.color">
</div>
<div v-if="form.object_type == 'file_meta_data_chroma_video'">
    <div class="flex">
        <label for="threshold_percentage">Threshold percentage</label>
    </div>
    <input class="input-black" type="number" min="0" max="100" id="threshold_percentage"
    @input="$emit('update:thresholdPercentage', $event.target.value)"
    :value="form.threshold_percentage">
</div>
<!-- end fields -->
</template>

<script>

export default {
    props: ['form'],
    emits: [
        'update:copyrightText',
        'update:copyrightLink',
        'update:physicalWidth',
        'update:color',
        'update:thresholdPercentage'
    ],
}
</script>